import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { RadioButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledModalTitle = styled.h5`
    ${setFontVariant("h5_2", colorsPalettes.carbon["500"])};
    padding: 20px 24px;
    margin: 0;
`;

export const StyledModalContent = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon["400"])};
    padding: 24px;
    margin: 0;
`;

export const StyledModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    column-gap: 4px;
    padding: 8px 16px;

    & .unsubscribeButton {
        margin-right: auto;
    }
`;

export const StrongText = styled.span`
    font-weight: 500;
`;

export const SubscriptionRadioButtonLabel = styled(Flex)`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const StyledRadioButton = styled(RadioButton)`
    padding: 0;
`;
